import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { getDraftShareIdFromQueryParam } from '@confluence/route-manager-utils/entry-points/getDraftShareIdFromQueryParam.ts';

import useEmojiEverSetPropertyQuery from './emoji-title/__generated__/useEmojiEverSetPropertyQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export const preloadEmojiEverSetProperty = (
	contentId: string,
): Promise<{
	data: unknown;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> => {
	return query({
		query: useEmojiEverSetPropertyQuery,
		variables: {
			contentId,
			status: ['current', 'draft'],
			draftShareId: getDraftShareIdFromQueryParam(),
		},
	});
};
